import angular from 'angular';

const module = angular.module('whyline.modals.holiday-info', [
]);

const HolidayInfoController = ($scope, $uibModalInstance, holiday) => {
  'ngInject';

  $scope.holiday = holiday;

  const messages = {
    servicePlural: 'applied_to_the_areas',
    serviceSingular: 'applied_to_the_area',
    linePlural: 'applied_to_the_lines',
    lineSingular: 'applied_to_the_line',
    allServices: 'all_services',
    allLines: 'place and lines',
  }
  $scope.applyAll = holiday.applyToAll;

  const configureMessage = () => {

    if (holiday.applyToAll && holiday.queueType === 'line') {
      $scope.appliedTo = messages.allLines;
      return;
    } else if (holiday.applyToAll && holiday.queueType === 'area') {
      $scope.appliedTo = messages.allServices;
      return;
    } else if (!holiday.applyToAll && holiday.queueType === 'line' && holiday.queueIds.length > 1) {
      $scope.appliedTo = messages.linePlural;
      return;
    } else if (!holiday.applyToAll && holiday.queueType === 'area' && holiday.queueIds.length > 1) {
      $scope.appliedTo = messages.servicePlural;
      return;
    } else if (!holiday.applyToAll && holiday.queueType === 'line' && holiday.queueIds.length === 1) {
      $scope.appliedTo = messages.lineSingular;
      return;
    } else if (!holiday.applyToAll && holiday.queueType === 'area' && holiday.queueIds.length === 1) {
      $scope.appliedTo = messages.serviceSingular;
      return;
    }
  }

  configureMessage();

  // Close modal
  $scope.cancel = () => {
    $uibModalInstance.close('cancel');
  };
};

module.exports = module.controller('HolidayInfoController', HolidayInfoController);
